import { isDevelopment } from '@frontend/env';
import { reportError } from './errorReporting';

/** The first real Error among the arguments — how every catch handler calls
 * this (`Logger.log('<what> failed', e)`). Exported for the unit test. */
export function findErrorArg(args: unknown[]): Error | undefined {
  return args.find((a): a is Error => a instanceof Error);
}

// A caught failure that only reaches a dev-gated console.log is invisible in
// production — no console, no error report. Routing the error-shaped calls
// through reportError here, rather than at every catch site, means the ~30
// existing handlers and every future one report without remembering to.
// Purely informational calls (no Error argument) stay console-only.
function log(...args: unknown[]) {
  if (isDevelopment) {
    console.log(...args);
  }
  const error = findErrorArg(args);
  if (error) {
    const context = args.find((a) => typeof a === 'string') ?? 'Logger.log';
    reportError(String(context), error);
  }
}

export default {
  log,
};
